<template>
  <div v-if="visible">
    <BLWinkelgebiedenLayer
      :loaded="loaded"
      :layer-visibility="layerVisibility"
    />
    <BLBedrijventerreinLayer
      :loaded="loaded"
      :layer-visibility="layerVisibility"
    />
    <BLGroteWinkelsLayer
      :loaded="loaded"
      :layer-visibility="layerVisibility"
    />
    <BLRestaurantsLangsWegLayer
      :loaded="loaded"
      :layer-visibility="layerVisibility"
    />
  </div>
</template>

<script>
import BLRestaurantsLangsWegLayer from '@/components/map/national/BLRestaurantsLangsWegLayer'
import BLGroteWinkelsLayer from '@/components/map/national/BLGroteWinkelsLayer'
import BLWinkelgebiedenLayer from '@/components/map/national/BLWinkelgebiedenLayer'
import BLBedrijventerreinLayer from '@/components/map/national/BLBedrijventerreinLayer'

import userMixin from '@/mixins/common/userMixin'
import { mapGetters } from 'vuex'

export default {
  components: {
    BLRestaurantsLangsWegLayer, BLGroteWinkelsLayer, BLWinkelgebiedenLayer, BLBedrijventerreinLayer,
  },
  mixins: [userMixin],
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      layerName: 'visitorslocations_bundle',
    }
  },
  computed: {
    ...mapGetters('deployment', [
      'DeploymentLayerName',
    ]),
    ...mapGetters('access', [
      'canAccessLayer',
    ]),
    ...mapGetters('layers', [
      'getActiveLayers',
    ]),
    sourceName() {
      return this.DeploymentLayerName({ layer: this.layerName })
    },
    visible() {
      if (!this.sourceName) return false
      if (!this.canAccessLayer({ id: this.layerName })) {
        return false
      }

      return true
    },
    bundleLayer() {
      return this.getActiveLayers?.find(layer => layer.id === this.layerName)
    },
    isPrimaryBundleLayer() {
      return this.bundleLayer?.status === 'primary'
    },
    layerVisibility() {
      return this.isPrimaryBundleLayer && this.bundleLayer?.visible
    },
  },
}
</script>

